import { Box, Button, Container, Flex, Heading, HoverCard, RadioGroup, Table, Text, TextArea, TextField } from "@radix-ui/themes";
import { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {IRegistryBookMemory, IRegistryCompanies, IRegistryFactories, IRegistryNotVerify, IRegistryPersonalities} from '../../core/types/services-types/registry-types'
import useFetch from '../../core/hooks/useFetch'
import RegistryNotVerifyService from '../../core/services/RegistryNotVerifyService'
import RegistryBookMemoryService from '../../core/services/RegistryBookMemoryService'
import RegistryPersonalitiesService from "../../core/services/RegistryPersonalitiesService";
import RegistryCompaniesService from '../../core/services/RegistryCampaniesService'
import RegistryFactoriesService from '../../core/services/RegistryFactoriesService'
import AppTable from "../../components/controls/tables/AppTable";
import moment from "moment";
import { CrossCircledIcon, DownloadIcon, MixerVerticalIcon, UpdateIcon, UploadIcon } from "@radix-ui/react-icons";
import { toast, ToastContainer } from "react-toastify";
import MaskInput from "../../components/controls/inputs/MaskInput";
import BaseModal from "../../components/controls/modals/BaseModal";
import { form_to_json } from "../../utils";
import FileInput from '../../components/controls/inputs/FIleInput'
import { FileArray } from "./create-post";
import Pagination from '../../components/common/renders/pagination-render'
import {exportExcelTemplate} from '../../utils/excel'
import { Link } from "react-router";
import { Avatar } from "radix-ui";
export default function Registry() {

    const [activeTable, setActiveTable] = useState<'book-memory' | 'not-verify' | 'personalities' | 'companies' | 'factories'>('not-verify')
    const [registryBookMemory, setRegistryBookMemory] = useState<IRegistryBookMemory[]>([])
    const [registryBookMemoryTotal, setRegistryBookMemoryTotal] = useState<number>(0)
    const [registryBookMemoryPage, setRegistryBookMemoryPage] = useState<number>(0)
    const [registryBookMemoryCount, setRegistryBookMemoryCount] = useState<number>(100)
    const [registryPersonalities, setRegistryPersonalities] = useState<IRegistryPersonalities[]>([])
    const [registryPersonalitiesTotal, setRegistryPersonalitiesTotal] = useState<number>(0)
    const [registryPersonalitiesPage, setRegistryPersonalitiesPage] = useState<number>(0)
    const [registryPersonalitiesCount, setRegistryPersonalitiesCount] = useState<number>(100)
    const [registryNotVerify, setRegistryNotVerify] = useState<IRegistryNotVerify[]>([])
    const [registryNotVerifyTotal, setRegistryNotVerifyTotal] = useState<number>(0)
    const [registryNotVerifyPage, setRegistryNotVerifyPage] = useState<number>(0)
    const [registryNotVerifyCount, setRegistryNotVerifyCount] = useState<number>(100)
    const [registryCompanies, setRegistryCompanies] = useState<IRegistryCompanies[]>([])
    const [registryCompaniesTotal, setRegistryCompaniesTotal] = useState<number>(0)
    const [registryCompaniesPage, setRegistryCompaniesPage] = useState<number>(0)
    const [registryCompaniesCount, setRegistryCompaniesCount] = useState<number>(100)
    const [registryFactories, setRegistryFactories] = useState<IRegistryFactories[]>([])
    const [registryFactoriesTotal, setRegistryFactoriesTotal] = useState<number>(0)
    const [registryFactoriesPage, setRegistryFactoriesPage] = useState<number>(0)
    const [registryFactoriesCount, setRegistryFactoriesCount] = useState<number>(100)
    const [openRegistryModalCreate, setOpenRegistryModalCreate] = useState<boolean>(false)
    const [openRegistryModalCreateFromExcel, setOpenRegistryModalCreateFromExcel] = useState<boolean>(false)
    const [openRegistryBookMemoryModalUpdate, setOpenRegistryBookMemoryModalUpdate] = useState<boolean>(false)
    const [openRegistryNotVerifyModalUpdate, setOpenRegistryNotVerifyModalUpdate] = useState<boolean>(false)
    const [openRegistryPersonalitiesModalUpdate, setOpenRegistryPersonalitiesModalUpdate] = useState<boolean>(false)
    const [openRegistryFactoriesModalUpdate, setOpenRegistryFactoriesModalUpdate] = useState<boolean>(false)
    const [openRegistryCompaniesModalUpdate, setOpenRegistryCompaniesModalUpdate] = useState<boolean>(false)
    const [selectedBookMemory, setSelectedBookMemory] = useState<IRegistryBookMemory | null>(null)
    const [selectedPersonalities, setSelectedPersonalities] = useState<IRegistryPersonalities | null>(null)
    const [selectedNotVerify, setSelectedNotVerify] = useState<IRegistryNotVerify | null>(null)
    const [selectedCompanies, setSelectedCompanies] = useState<IRegistryCompanies | null>(null)
    const [selectedFactories, setSelectedFactories] = useState<IRegistryFactories | null>(null)
    const [excelFile, setExcelFile] = useState<FileArray[]>([])
    const [filtersVisible, setFiltersVisible] = useState<boolean>(false)
    // registry book memory model fields
    const bookMemoryForm = useRef<HTMLFormElement | null>(null)
    const bookNotVerifyForm = useRef<HTMLFormElement | null>(null)
    const bookPersonalitiesForm = useRef<HTMLFormElement | null>(null)
    const bookCompaniesForm = useRef<HTMLFormElement | null>(null)
    const factoriesForm = useRef<HTMLFormElement | null>(null)
    const filtersForm = useRef<HTMLFormElement | null>(null)
    const [dateSort, setDateSort] = useState<'DESC' | 'ASC'>('DESC')
    const onChangePage = (page: number) => {
         
        if(activeTable === 'book-memory') setRegistryBookMemoryPage(page)
        else if(activeTable === 'not-verify') setRegistryNotVerifyPage(page)
        else if(activeTable === 'personalities') setRegistryPersonalitiesPage(page)
        else if(activeTable === 'companies') setRegistryCompaniesPage(page)
        else if(activeTable === 'factories') setRegistryFactoriesPage(page)
    }

    const registryBookMemoryHeadersTableFormat = useMemo<(string | ReactNode)[]>(() =>
        [
            "ID",
            "Фамилия",
            "Имя",
            "Отчество",
            "Дата рождения",
            "Место рождения",
            "Дата смерти",
            "Гражданство",
            "Место призыва",
            "Звание",
            "Место службы",
            "Судьба",
            "Герои",
            "Баланс",
            "Создано",
            "Обновлено",
            "Действия"
    ], [])

    const registryPersonalitiesHeadersTableFormat = useMemo<(string | ReactNode)[]>(
     () =>  [
            "ID",
            "Фамилия",
            "Имя",
            "Отчество",
            "Дата рождения",
            "Дата смерти",
            "Гражданство",
            "Вид деятельности",
            "Биография",
            "Баланс",
            "Резервный баланс",
            "Создано",
            "Обновлено",
            "Действия"
    ], [])

     const registryNotVerifyHeadersTableFormat = useMemo<(string | ReactNode)[]>(
        () => [
            "ID",
            "Фамилия",
            "Имя",
            "Отчество",
            "Гражданство",
            "Пол",
            "Дата рождения",
            "Серия паспорта",
            "Номер паспорта",
            "Кем выдан паспорт",
            "Дата выдачи паспорта",
            "Код подразделения",
            "ИНН",
            "СНИЛС",
            "Полис ОМС",
            "Серия Свидетельства о рождении",
            "Номер Свидетельства о рождении",
            "Свидетельство о рождении кем выдано",
            "Свидетельство о рождении когда выдано",
            "Серия военного билета",
            "Номер военного билета",
            "Емейл",
            "Телефон",
            "Баланс",
            "Создано",
            "Обновлено",
            "Действия"
    ], [])

        
      const registryCompaniesHeadersTableFormat = useMemo<(string | ReactNode)[]>(
        () => [
            "ID",
            "Ссылка",
            "Наименование",
            "Юридическое наименование",
            "Статус",
            "Руководитель",
            "ИНН",
            "ОГРН",
            "Телефон (один из)",
            "E-mail",
            "Сайт",
            "Юридический адрес",
            "Сотрудников",
            "Выручка (Ф2.2110)",
            "Прибыль (Ф2.2400)",
            "Стоимость (Ф1.1300)",
            "Описание",
            "В избранном",
            "Создано",
            "Обновлено",
            "Действия"
    ], [])
 

    const registryFactoriesHeadersTableFormat = useMemo<(string | ReactNode)[]>(
        () => [
            "ID",
            "Регионы",
            "Предприятия",
            "Объединения",
            "Комбинаты",
            "Лесхозы",
            "Адрес",
            "ФИО Руководителя",
            "телефон; факс",
            "Собственность",
            "инф. по состоянию на",
            "рег. номер",
            "Год основания",
            "Численность чел.",
            "Объем",
            "Износ ОФ",
            "Остат. стоим. ОФ",
            "Продукция и услуги",
            "Использование сырья и материалов",
            "Создано",
            "Обновлено",
            "Действия"
    ], [])

    const [fetchRegistryBookMemory, isLoadingRegistryBookMemory, errorRegistryBookMemory, errorsRegistryBookMemory] = useFetch(async () => {
        const data = await RegistryBookMemoryService.GetAll(registryBookMemoryCount, registryBookMemoryPage)
        setRegistryBookMemory(data.data)
        setRegistryBookMemoryTotal(data.count)
}
)

    const [fetchRegistryBookMemoryFilters, isLoadingRegistryBookMemoryFilters, errorRegistryBookMemoryFilters, errorsRegistryBookMemoryFilters] = useFetch(async (form: FormData) => {
        if(form) {
        const json = form_to_json<Object>(form)
        const data = await RegistryBookMemoryService.GetAllFilters(dateSort, registryBookMemoryCount, registryBookMemoryPage, json)
        setRegistryBookMemory(data.data)
        setRegistryBookMemoryTotal(data.count)
        }
    })

    const [fetchRegistryBookMemoryCreate, isLoadingRegistryBookMemoryCreate, errorRegistryBookMemoryCreate, errorsRegistryBookMemoryCreate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryBookMemoryService.Add(json)
        setRegistryBookMemory(prev => prev.concat(data))
        toast.success("Запись успешно добавлена!")
        setOpenRegistryModalCreate(false)
    })


    const [fetchRegistryBookMemoryCreateFromExcel, isLoadingRegistryBookMemoryCreateFromExcel, errorRegistryBookMemoryCreateFromExcel, errorsRegistryBookMemoryCreateFromExcel] = useFetch(async () => {
        const formData = new FormData()
        if(!excelFile.length) {
            return
        }
        setOpenRegistryModalCreateFromExcel(false)
        formData.append('excel', excelFile[0].file)
        const data = await RegistryBookMemoryService.AddFromExcel(formData)
        setRegistryBookMemory(prev => prev.concat(data))
        toast.success("Записи успешно добавлены!")
    })

    const [fetchRegistryBookMemoryDelete, isLoadingRegistryBookMemoryDelete, errorRegistryBookMemoryDelete, errorsRegistryBookMemoryDelete] = useFetch(async (id: number) => {
        const data = await RegistryBookMemoryService.Delete(id)
        setRegistryBookMemory(prev => prev.filter(tr => tr.id !== id))
        console.log(registryBookMemory)
        toast.success(data.message)
    })

    const [fetchRegistryBookMemoryUpdate, isLoadingRegistryBookMemoryUpdate, errorRegistryBookMemoryUpdate, errorsRegistryBookMemoryUpdate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const model_id = form.get('id')
        if(model_id) {
        const data = await RegistryBookMemoryService.Update(json)
           const updated = registryBookMemory.map(item => {
            if (item.id.toString() == model_id) {
                return data
            }
            return item
        })
        setRegistryBookMemory(updated)
        toast.success("Запись успешно изменена!")
        setOpenRegistryBookMemoryModalUpdate(false)
    }
    })


    const [fetchRegistryNotVerify, isLoadingRegistryNotVerify, errorRegistryNotVerify, errorsRegistryNotVerify] = useFetch(async () => {
        const data = await RegistryNotVerifyService.GetAll(registryNotVerifyCount, registryNotVerifyPage)
        setRegistryNotVerify(data.data)
        setRegistryNotVerifyTotal(data.count)
    })

    const [fetchRegistryNotVerifyFilters, isLoadingRegistryNotVerifyFilters, errorRegistryNotVerifyFilters, errorsRegistryNotVerifyFilters] = useFetch(async (form: FormData) => {
        if(form) {
        const json = form_to_json<Object>(form)
        const data = await RegistryNotVerifyService.GetAllFilters(dateSort, registryNotVerifyCount, registryNotVerifyPage, json)
        setRegistryNotVerify(data.data)
        setRegistryNotVerifyTotal(data.count)
        }
    })

    const [fetchRegistryNotVerifyCreate, isLoadingRegistryNotVerifyCreate, errorRegistryNotVerifyCreate, errorsRegistryNotVerifyCreate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryNotVerifyService.Add(json)
        setRegistryNotVerify(prev => prev.concat(data))
        toast.success("Запись успешно добавлена!")
        setOpenRegistryModalCreate(false)
    })

    const [fetchRegistryNotVerifyCreateFromExcel, isLoadingRegistryNotVerifyCreateFromExcel, errorRegistryNotVerifyCreateFromExcel, errorsRegistryNotVerifyCreateFromExcel] = useFetch(async () => {
        const formData = new FormData()
        if(!excelFile.length) {
            return
        }
        setOpenRegistryModalCreateFromExcel(false)
        formData.append('excel', excelFile[0].file)
        const data = await RegistryNotVerifyService.AddFromExcel(formData)
        setRegistryNotVerify(prev => prev.concat(data))
        toast.success("Записи успешно добавлены!")
    })

    const [fetchRegistryNotVerifyDelete, isLoadingRegistryNotVerifyDelete, errorRegistryNotVerifyDelete, errorsRegistryNotVerifyDelete] = useFetch(async (id: number) => {
        const data = await RegistryNotVerifyService.Delete(id)
        setRegistryNotVerify(prev => prev.filter(tr => tr.id !== id))
        console.log(registryNotVerify)
        toast.success(data.message)
    })

    const [fetchRegistryNotVerifyUpdate, isLoadingRegistryNotVerifyUpdate, errorRegistryNotVerifyUpdate, errorsRegistryNotVerifyUpdate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const model_id = form.get('id')
        if(model_id) {
        const data = await RegistryNotVerifyService.Update(json)
        const updated = registryNotVerify.map(item => {
            if (item.id.toString() == model_id) {
                return data
            }
            return item
        })
        setRegistryNotVerify(updated)
        toast.success("Запись успешно изменена!")
        setOpenRegistryNotVerifyModalUpdate(false)
    }
    })

    const [fetchRegistryPersonalities, isLoadingRegistryPersonalities, errorRegistryPersonalities, errorsRegistryPersonalities] = useFetch(async () => {
        const data = await RegistryPersonalitiesService.GetAll(registryPersonalitiesCount, registryPersonalitiesPage)
        setRegistryPersonalities(data.data)
        setRegistryPersonalitiesTotal(data.count)

    })

       const [fetchRegistryPersonalitiesFilters, isLoadingRegistryPersonalitiesFilters, errorRegistryPersonalitiesFilters, errorsRegistryPersonalitiesFilters] = useFetch(async (form: FormData) => {
        if(form) {
        const json = form_to_json<Object>(form)
        const data = await RegistryPersonalitiesService.GetAllFilters(dateSort, registryPersonalitiesCount, registryPersonalitiesPage, json)
        setRegistryPersonalities(data.data)
        setRegistryPersonalitiesTotal(data.count)
        }
    })

    const [fetchRegistryPersonalitiesCreate, isLoadingRegistryPersonalitiesCreate, errorRegistryPersonalitiesCreate, errorsRegistryPersonalitiesCreate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryPersonalitiesService.Add(json)
        setRegistryPersonalities(prev => prev.concat(data))
        toast.success("Запись успешно добавлена!")
        setOpenRegistryModalCreate(false)
    })

    const [fetchRegistryPersonalitiesCreateFromExcel, isLoadingRegistryPersonalitiesCreateFromExcel, errorRegistryPersonalitiesCreateFromExcel, errorsRegistryPersonalitiesCreateFromExcel] = useFetch(async () => {
        const formData = new FormData()
        if(!excelFile.length) {
            return
        }
        setOpenRegistryModalCreateFromExcel(false)
        formData.append('excel', excelFile[0].file)
        const data = await RegistryPersonalitiesService.AddFromExcel(formData)
        setRegistryPersonalities(prev => prev.concat(data))
        toast.success("Записи успешно добавлены!")
    })

    const [fetchRegistryPersonalitiesDelete, isLoadingRegistryPersonalitiesDelete, errorRegistryPersonalitiesDelete, errorsRegistryPersonalitiesDelete] = useFetch(async (id: number) => {
        const data = await RegistryPersonalitiesService.Delete(id)
        setRegistryPersonalities(prev => prev.filter(tr => tr.id !== id))
        console.log(registryPersonalities)
        toast.success(data.message)
    })

    const [fetchRegistryPersonalitiesUpdate, isLoadingRegistryPersonalitiesUpdate, errorRegistryPersonalitiesUpdate, errorsRegistryPersonalitiesUpdate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryPersonalitiesService.Update(json)
        const model_id = form.get('id')
        if(model_id) {
        const updated = registryPersonalities.map(item => {
            if (item.id.toString() == model_id) {
                return data
            }
            return item
        })
        setRegistryPersonalities(updated)
        toast.success("Запись успешно изменена!")
        setOpenRegistryPersonalitiesModalUpdate(false)
    }
    })

    const [fetchRegistryCompanies, isLoadingFetchRegistryCompanies, errorRegistryCompanies, errorsRegistryCompanies] = useFetch(async () => {
        const data = await RegistryCompaniesService.GetAll(registryCompaniesCount, registryCompaniesPage)
        setRegistryCompanies(data.data)
        setRegistryCompaniesTotal(data.count)
    })

        const [fetchRegistryCompaniesFilters, isLoadingRegistryCompaniesFilters, errorRegistryCompaniesFilters, errorsRegistryCompaniesFilters] = useFetch(async (form: FormData) => {
        if(form) {
        const json = form_to_json<Object>(form)
        const data = await RegistryCompaniesService.GetAllFilters(dateSort, registryCompaniesCount, registryCompaniesPage, json)
        setRegistryCompanies(data.data)
        setRegistryCompaniesTotal(data.count)
        }
    })


      const [fetchRegistryCompaniesCreate, isLoadingRegistryCompaniesCreate, errorRegistryCompaniesCreate, errorsRegistryCompaniesCreate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryCompaniesService.Add(json)
        setRegistryCompanies(prev => prev.concat(data))
        toast.success("Запись успешно добавлена!")
        setOpenRegistryModalCreate(false)
    })

      const [fetchRegistryCompaniesCreateFromExcel, isLoadingRegistryCompaniesCreateFromExcel, errorRegistryCompaniesCreateFromExcel, errorsRegistryCompaniesCreateFromExcel] = useFetch(async () => {
        const formData = new FormData()
        if(!excelFile.length) {
            return
        }
        setOpenRegistryModalCreateFromExcel(false)
        formData.append('excel', excelFile[0].file)
        const data = await RegistryCompaniesService.AddFromExcel(formData)
        setRegistryCompanies(prev => prev.concat(data))
        toast.success('Записи успешно добавлены!')
        

    })

      const [fetchRegistryCompaniesDelete, isLoadingRegistryCompaniesDelete, errorRegistryCompaniesDelete, errorsRegistryCompaniesDelete] = useFetch(async (id: number) => {
        const data = await RegistryCompaniesService.Delete(id)
        setRegistryCompanies(prev => prev.filter(tr => tr.id !== id))
        toast.success(data)
    })

       const [fetchRegistryCompaniesUpdate, isLoadingRegistryCompaniesUpdate, errorRegistryCompaniesUpdate, errorsRegistryCompaniesUpdate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryCompaniesService.Update(json)
        const model_id = form.get('id')
        if(model_id) {
        const updated = registryCompanies.map(item => {
            if (item.id.toString() == model_id) {
                return data
            }
            return item
        })
        setRegistryCompanies(updated)
        toast.success("Запись успешно изменена!")
        setOpenRegistryCompaniesModalUpdate(false)
    }
    })


    const [fetchRegistryFactories, isLoadingFetchRegistryFactories, errorFetchRegistryFactories, errorsFetchRegistryFactories] = useFetch(async () => {
        const data = await RegistryFactoriesService.GetAll(registryFactoriesCount, registryFactoriesPage)
        setRegistryFactories(data.data)
        setRegistryFactoriesTotal(data.count)
    })


    const [fetchRegistryFactoriesFilters, isLoadingRegistryFactoriesFilters, errorRegistryFactoriesFilters, errorsRegistryFactoriesFilters] = useFetch(async (form: FormData) => {
        if(form) {
        const json = form_to_json<Object>(form)
        const data = await RegistryFactoriesService.GetAllFilters(dateSort, registryFactoriesCount, registryFactoriesPage, json)
        setRegistryFactories(data.data)
        setRegistryFactoriesTotal(data.count)
        }
    })

    const [fetchRegistryFactoriesCreate, isLoadingRegistryFactoriesCreate, errorRegistryFactoriesCreate, errorsRegistryFactoriesCreate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryFactoriesService.Add(json)
        setRegistryFactories(prev => prev.concat(data))
        toast.success("Запись успешно добавлена!")
        setOpenRegistryModalCreate(false)
    })

      const [fetchRegistryFactoriesCreateFromExcel, isLoadingRegistryFactoriesCreateFromExcel, errorRegistryFactoriesCreateFromExcel, errorsRegistryFactoriesCreateFromExcel] = useFetch(async () => {
        const formData = new FormData()
        if(!excelFile.length) {
            return
        }
        setOpenRegistryModalCreateFromExcel(false)
        formData.append('excel', excelFile[0].file)
        const data = await RegistryFactoriesService.AddFromExcel(formData)
        setRegistryFactories(prev => prev.concat(data))
        toast.success('Записи успешно добавлены!')
        

    })

    const [fetchRegistryFactoriesDelete, isLoadingRegistryFactoriesDelete, errorRegistryFactoriesDelete, errorsRegistryFactoriesDelete] = useFetch(async (id: number) => {
        const data = await RegistryFactoriesService.Delete(id)
        setRegistryFactories(prev => prev.filter(tr => tr.id !== id))
        toast.success(data)
    })

       const [fetchRegistryFactoriesUpdate, isLoadingRegistryFactoriesUpdate, errorRegistryFactoriesUpdate, errorsRegistryFactoriesUpdate] = useFetch(async (form: FormData) => {
        const json = form_to_json<Object>(form)
        console.log(json)
        const data = await RegistryFactoriesService.Update(json)
        const model_id = form.get('id')
        if(model_id) {
        const updated = registryFactories.map(item => {
            if (item.id.toString() == model_id) {
                return data
            }
            return item
        })
        setRegistryFactories(updated)
        toast.success("Запись успешно изменена!")
        setOpenRegistryFactoriesModalUpdate(false)
    }
    })

       const renderOption = (key: string, value: any) => {
     
        if(key === 'createdAt' || key === 'updatedAt') {
           return ( 
            <Table.Cell key={key}>
           { moment(value).format("DD.MM.YYYY HH:mm")}
            </Table.Cell>
           )
        }
        if(key.includes('link')) {
            return (
                <Table.Cell key={key}>
                    <Link target="_blank" to={value}>{value}</Link>
                </Table.Cell>
            )
        }
        return <Table.Cell key={key}>{value}</Table.Cell>
    }


    const onSubmitCreateFromExcel = async () => {
        if (activeTable === 'book-memory') {
            await fetchRegistryBookMemoryCreateFromExcel()
        }
        if (activeTable === 'not-verify') {
            await fetchRegistryNotVerifyCreateFromExcel()
        }
        if (activeTable === 'personalities') {
            await fetchRegistryPersonalitiesCreateFromExcel()
        }
        if(activeTable === 'companies') {
            await fetchRegistryCompaniesCreateFromExcel()
        }
        if(activeTable === 'factories') {
            await fetchRegistryFactoriesCreateFromExcel()
        }
    }

    
    // TODO: OPTIMIZATION

    const onSubmitCreateBookMemory = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        console.log(bookMemoryForm.current)
        if (bookMemoryForm.current) {
            const form = new FormData(bookMemoryForm.current)
           
            await fetchRegistryBookMemoryCreate(form)
        }
    }

    const onSubmitUpdateBookMemory = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        console.log(bookMemoryForm.current)
        if (bookMemoryForm.current) {
            const form = new FormData(bookMemoryForm.current)
             
            await fetchRegistryBookMemoryUpdate(form)
        }
    }

    const onSubmitCreateNotVerify = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (bookNotVerifyForm.current) {
            const form = new FormData(bookNotVerifyForm.current)
            
            await fetchRegistryNotVerifyCreate(form)
        }
    }

    const onSubmitUpdateNotVerify = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (bookNotVerifyForm.current) {
            const form = new FormData(bookNotVerifyForm.current)
             
            await fetchRegistryNotVerifyUpdate(form)
        }
    }

    const onSubmitCreatePersonalities = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
         if (bookPersonalitiesForm.current) {
            const form = new FormData(bookPersonalitiesForm.current)
            
            await fetchRegistryPersonalitiesCreate(form)
        }
    }

    const onSubmitUpdatePersonalities = async (e: React.FormEvent<HTMLFormElement>) => {
         e.preventDefault()
         if (bookPersonalitiesForm.current) {
            const form = new FormData(bookPersonalitiesForm.current)
            await fetchRegistryPersonalitiesUpdate(form)
        }
    }

    const onSubmitCreateCompanies = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if(bookCompaniesForm.current) {
            const form = new FormData(bookCompaniesForm.current)
            await fetchRegistryCompaniesCreate(form)
        }
    }

    const onSubmitUpdateCompanies = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if(bookCompaniesForm.current) {
            const form = new FormData(bookCompaniesForm.current)
            await fetchRegistryCompaniesUpdate(form)
        }
    }

    const onSubmitCreateFactories = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if(factoriesForm.current) {
            const form = new FormData(factoriesForm.current)
            await fetchRegistryFactoriesCreate(form)
        }
    }

    const onSubmitUpdateFactories = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if(factoriesForm.current) {
            const form = new FormData(factoriesForm.current)
            await fetchRegistryFactoriesUpdate(form)
        }
    }

    // TODO: OPTIMIZATION // 


    const onSubmitFilters = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
         if (filtersForm.current) {
            const form = new FormData(filtersForm.current)
            if(activeTable === 'book-memory') {
                await fetchRegistryBookMemoryFilters(form)
            }
            else if(activeTable === 'not-verify') {
                await fetchRegistryNotVerifyFilters(form)
            }
            else if(activeTable === 'personalities') {
                await fetchRegistryPersonalitiesFilters(form)
            }
            else if(activeTable === 'companies') {
                await fetchRegistryCompaniesFilters(form)
            }
            else {
                await fetchRegistryFactoriesFilters(form)
            }
        }
    }

    const onDownloadTemplate = () => {
        if(activeTable === 'book-memory') {
            exportExcelTemplate(registryBookMemoryHeadersTableFormat.slice(1, -3), null, (e) => toast.error(`Произошла ошибка при формировании Excel файла! ${e.message}`))
        }
        else if(activeTable === 'companies') {
            exportExcelTemplate(registryCompaniesHeadersTableFormat.slice(1, -3), null, (e) => toast.error(`Произошла ошибка при формировании Excel файла! ${e.message}`))
        }
        else if(activeTable === 'not-verify') {
            exportExcelTemplate(registryNotVerifyHeadersTableFormat.slice(1, -3), null, (e) => toast.error(`Произошла ошибка при формировании Excel файла! ${e.message}`))
        }
        else if(activeTable === 'personalities') {
            exportExcelTemplate(registryPersonalitiesHeadersTableFormat.slice(1, -3), null, (e) => toast.error(`Произошла ошибка при формировании Excel файла! ${e.message}`))
        }
        else {
            exportExcelTemplate(registryFactoriesHeadersTableFormat.slice(1, -3), null, e => toast.error(`Произошла ошибка при формировании Excel файла! ${e.message}`))
        }
         
    }



    const renderRegistryCreateFromExcelModal = (
        <Flex direction={'column'} gap={'5'}> 
         <FileInput 
            id="grgtrg"
            setFileInStore={setExcelFile}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            contentLabel={<Flex align={'center'} justify={'center'} direction={'column'}><UploadIcon width={'30px'} height={'30px'} /> <Text weight={'bold'}>Excel файл</Text> <Text>Выберите или перетащите сюда</Text> </Flex>} classNameContainer={`!flex !items-center !justify-center`} 
            />
        <Text>{excelFile.length ? excelFile[0].name : ''}</Text>
        <Button loading={isLoadingRegistryBookMemoryCreateFromExcel || isLoadingRegistryNotVerifyCreateFromExcel || isLoadingRegistryPersonalitiesCreateFromExcel || isLoadingRegistryCompaniesCreateFromExcel} onClick={async () => await onSubmitCreateFromExcel()}>
            Сохранить записи
        </Button>
        </Flex>
    )


    const renderCreateBookMemoryModal = (model: IRegistryBookMemory | null) => {
        console.log(model)
        return (
        <Container>
            <form ref={bookMemoryForm} onSubmit={model ? onSubmitUpdateBookMemory : onSubmitCreateBookMemory}>
                <Flex direction={'column'} gap={'5'}>
                {model && 
                <Container>
                <Text>ID записи</Text>
                <TextField.Root name="id" placeholder="ID" readOnly defaultValue={model.id}>

                </TextField.Root>
                </Container>
                }
                <Container> 
                <Text>Имя</Text>
                <TextField.Root name="first_name" placeholder="Имя" defaultValue={model?.first_name || ''}>

                </TextField.Root>
                <Text color="red">{errorsRegistryBookMemoryCreate.first_name && errorsRegistryBookMemoryCreate.first_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Фамилия</Text>
                <TextField.Root name="second_name" placeholder="Фамилия" defaultValue={model?.second_name || ''}>

                </TextField.Root>
                <Text color="red">{errorsRegistryBookMemoryCreate.second_name && errorsRegistryBookMemoryCreate.second_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Отчество</Text>
                <TextField.Root name="sur_name" placeholder="Отчество" defaultValue={model?.sur_name || ''}>
                </TextField.Root>
               
                </Container>
                <Container> 
                     <Text>Дата рождения ({model?.date_of_birth ? `Текущая дата: ${model.date_of_birth}` : ''})</Text>
                 <TextField.Root name="date_of_birth" placeholder="Дата рождения" type="date" defaultValue={model?.date_of_birth || ''}></TextField.Root>
                 </Container>
                  <Container> 
                    <Text>Место рождения</Text>
                 <TextField.Root name="place_of_birth" placeholder="Место рождения" defaultValue={model?.place_of_birth || ''}></TextField.Root>
                 </Container>
                    <Container> 
                        <Text>Дата смерти ({model?.date_of_death ? `Текущая дата: ${model.date_of_death}` : ''})</Text>
                 <TextField.Root name="date_of_death" placeholder="Дата смерти" type="date" defaultValue={model?.date_of_death || ''}></TextField.Root>
                 </Container>
                    <Container> 
                        <Text>Гражданство</Text>
                 <TextField.Root name="nationality" placeholder="Гражданство" defaultValue={model?.nationality || ''}></TextField.Root>
                 </Container>
                <Container> 
                     <Text>Место призыва</Text>
                 <TextField.Root name="place_of_draft" placeholder="Место призыва" defaultValue={model?.place_of_draft || ''}></TextField.Root>
                 </Container>
                <Container> 
                     <Text>Звание</Text>
                 <TextField.Root name="rank" placeholder="Звание" defaultValue={model?.rank || ''}></TextField.Root>
                 </Container>
                  <Container> 
                     <Text>Место службы</Text>
                 <TextField.Root name="place_of_corps" placeholder="Место службы" defaultValue={model?.place_of_corps || ''}></TextField.Root>
                 </Container>
                <Container> 
                <Text>Судьба</Text>
                <TextField.Root name="fate" placeholder="Судьба" defaultValue={model?.fate || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Герои</Text>
                <TextField.Root name="heroes" placeholder="Герои" defaultValue={model?.heroes || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Баланс</Text>
                <TextField.Root name="balance" placeholder="Баланс" type="number" defaultValue={model?.balance || 0}>

                </TextField.Root>
                </Container>
                 <Button loading={isLoadingRegistryBookMemoryCreate || isLoadingRegistryBookMemoryUpdate}>
                    Сохранить
                </Button>
                </Flex>
                
            </form>
        </Container>
        )
    }

    const renderCreatePersonalitiesModal = (model: IRegistryPersonalities | null) => {
        console.log(model)
        return (
        <Container>
            <form ref={bookPersonalitiesForm} onSubmit={model ? onSubmitUpdatePersonalities : onSubmitCreatePersonalities}>
                <Flex direction={'column'} gap={'5'}> 
                 {model && 
                <Container>
                <Text>ID записи</Text>
                <TextField.Root name="id" placeholder="ID" readOnly defaultValue={model.id}>

                </TextField.Root>
                </Container>
                }
                <Container> 
                <Text>Имя</Text>
                <TextField.Root name="first_name" placeholder="Имя" defaultValue={model?.first_name || ''}>

                </TextField.Root>
                <Text color="red">{errorsRegistryPersonalitiesCreate.first_name && errorsRegistryPersonalitiesCreate.first_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Фамилия</Text>
                <TextField.Root name="second_name" placeholder="Фамилия" defaultValue={model?.second_name || ''}>

                </TextField.Root>
                <Text color="red">{errorsRegistryPersonalitiesCreate.second_name && errorsRegistryPersonalitiesCreate.second_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Отчество</Text>
                <TextField.Root name="sur_name" placeholder="Отчество" defaultValue={model?.sur_name || ''}>
                </TextField.Root>
               
                </Container>
                
                <Container> 
                <Text>Дата рождения ({model?.date_of_birth ? `Текущая дата: ${model.date_of_birth}` : ''})</Text>
                 <TextField.Root name="date_of_birth" placeholder="Дата рождения" type="date" defaultValue={model?.date_of_birth || ''}></TextField.Root>
                 </Container>
                    <Container> 
                    <Text>Дата смерти ({model?.date_of_death ? `Текущая дата: ${model.date_of_death}` : ''})</Text>
                 <TextField.Root name="date_of_death" placeholder="Дата смерти" type="date" defaultValue={model?.date_of_death || ''}></TextField.Root>
                 </Container>
                <Container> 
                    <Text>Гражданство</Text>
                 <TextField.Root name="nationality" placeholder="Гражданство" defaultValue={model?.nationality || ''}></TextField.Root>
                 </Container>
                 <Container>
                    <Text>Вид деятельности</Text>
                    <TextField.Root name="activity" placeholder="Вид деятельности" defaultValue={model?.activity || ''}></TextField.Root>
                 </Container>


                <Container> 
                <Text>Биография</Text>
                <TextArea rows={20} cols={20} name="biography" placeholder="Биография" defaultValue={model?.biography || ''}>

                </TextArea>
                </Container>
                <Container> 
                <Text>Баланс</Text>
                <TextField.Root name="balance" placeholder="Баланс" type="number" defaultValue={model?.balance || 0}>

                </TextField.Root>
                </Container>
                <Button loading={isLoadingRegistryPersonalitiesCreate || isLoadingRegistryPersonalitiesUpdate}>
                    Сохранить
                </Button>
                </Flex>
                 
            </form>
        </Container>
        )
    }

      const renderCreateNotVerifyModal = (model: IRegistryNotVerify | null) => {
        console.log(model)
        return (
        <Container>
            <form ref={bookNotVerifyForm} onSubmit={model ? onSubmitUpdateNotVerify : onSubmitCreateNotVerify}>
                <Flex direction={'column'} gap={'5'}> 
                  {model && 
                <Container>
                <Text>ID записи</Text>
                <TextField.Root name="id" placeholder="ID" readOnly defaultValue={model.id}>

                </TextField.Root>
                </Container>
                }
                <Container> 
                <Text>Имя</Text>
                <TextField.Root name="first_name" placeholder="Имя" defaultValue={model?.first_name || ''}>

                </TextField.Root>
                <Text color="red">{errorsRegistryNotVerifyCreate.first_name && errorsRegistryNotVerifyCreate.first_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Фамилия</Text>
                <TextField.Root name="second_name" placeholder="Фамилия" defaultValue={model?.second_name || ''}>

                </TextField.Root>
                 <Text color="red">{errorsRegistryNotVerifyCreate.second_name && errorsRegistryNotVerifyCreate.second_name.msg}</Text>
                </Container>
                <Container> 
                <Text>Отчество</Text>
                <TextField.Root name="sur_name" placeholder="Отчество" defaultValue={model?.sur_name || ''}>
                </TextField.Root>
               
                </Container>
                 <Container> 
                <Text>Гражданство</Text>
                <TextField.Root name="nationality" placeholder="Национальность" defaultValue={model?.nationality || ''}>
                </TextField.Root>
                </Container>
                <Container>
                    <Text>Пол</Text>
                    <RadioGroup.Root name="sex" defaultValue={model?.sex.toUpperCase() || ''}>
	                <RadioGroup.Item value="М">Мужской</RadioGroup.Item>
	                <RadioGroup.Item value="Ж">Женский</RadioGroup.Item>
                    </RadioGroup.Root>
                </Container>
                  <Container> 
                <Text>Дата рождения ({model?.date_of_birth ? `Текущая дата: ${model.date_of_birth}` : ''})</Text>
                <TextField.Root name="date_of_birth" placeholder="Дата рождения" type="date" defaultValue={model?.date_of_birth || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>Серия паспорта</Text>
                <MaskInput name="series_passport" placeholder="Серия паспорта" mask="____" replacement={{ _: /\d/ }} defaultValue={model?.series_passport || ''} />
                </Container>
                 <Container> 
                <Text>Номер паспорта</Text>
                <MaskInput name="number_passport" placeholder="Номер паспорта" mask="______" replacement={{ _: /\d/ }} defaultValue={model?.number_passport || ''} />
                </Container>
                <Container> 
                <Text>Кем выдан паспорт</Text>
                <TextField.Root name="whom_issue_passport" placeholder="Кем выдан паспорт" defaultValue={model?.whom_issue_passport || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Дата выдачи паспорта</Text>
                <TextField.Root name="date_issue_passport" placeholder="Дата выдачи паспорта" type="date" defaultValue={model?.date_issue_passport || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Код подразделения паспорта</Text>
                <MaskInput name="department_code_passport" placeholder="Код подразделения паспорта" mask="___-___" replacement={{ _: /\d/ }} defaultValue={model?.department_code_passport || ''} />
                </Container>
                <Container> 
                <Text>ИНН</Text>
                <MaskInput name="inn" placeholder="ИНН" mask="____________" replacement={{ _: /\d/ }} defaultValue={model?.inn || ''} />
                </Container>
                <Container> 
                <Text>СНИЛС</Text>
                <MaskInput name="snils" placeholder="СНИЛС" mask="___-___-___ __" replacement={{ _: /\d/ }} defaultValue={model?.snils || ''} />
                </Container>
                <Container>
                <Text>Номер полиса ОМС</Text>
                <MaskInput name="oms" placeholder="Номер полиса ОМС" mask="________________" replacement={{ _: /\d/ }} defaultValue={model?.oms || ''} />
                </Container>
                <Container>
                <Text>Серия Свидетельства о рождении</Text> 
                <TextField.Root name="document_of_date_birth_series" placeholder="Серия Свидетельства о рождении" defaultValue={model?.document_of_date_birth_series || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Номер Свидетельства о рождении</Text> 
                <TextField.Root name="document_of_date_birth_number" placeholder="Номер Свидетельства о рождении" defaultValue={model?.document_of_date_birth_number || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Свидетельство о рождении кем выдано</Text> 
                <TextField.Root name="document_of_date_birth_whom_issue" placeholder="Свидетельство о рождении кем выдано" defaultValue={model?.document_of_date_birth_whom_issue || ''}>

                </TextField.Root>
                </Container>
                 <Container>
                <Text>Свидетельство о рождении когда выдано</Text> 
                <TextField.Root name="document_of_date_birth_date_issue" type="date" placeholder="Свидетельство о рождении когда выдано" defaultValue={model?.document_of_date_birth_date_issue || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Серия военного билета</Text>
                <MaskInput name="series_military_document" placeholder="AA" mask="++" replacement={{ "+": /[A-Za-zА-Яа-я]/ }} defaultValue={model?.series_military_document || ''} />
                </Container>
                  <Container> 
                <Text>Номер военного билета</Text>
                <MaskInput name="number_military_document" placeholder="0000000" mask="_______" replacement={{ _: /\d/, }} defaultValue={model?.number_military_document || ''} />
                </Container>
                <Container> 
                <Text>Емейл</Text>
                <TextField.Root name="email" placeholder="Емейл" defaultValue={model?.email || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Номер телефона</Text>
                  <TextField.Root name="phone_number" placeholder="Телефон" defaultValue={model?.phone_number || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Баланс</Text>
                <TextField.Root name="balance" placeholder="Баланс" type="number" defaultValue={model?.balance || ''}>

                </TextField.Root>
                </Container>
                <Button loading={isLoadingRegistryNotVerifyCreate || isLoadingRegistryNotVerifyUpdate}>
                    Сохранить
                </Button>
                </Flex>
            </form>
        </Container>
        )
      }

      const renderCreateCompaniesModal = (model: IRegistryCompanies | null) => {
        return (
            <Container>
                <form ref={bookCompaniesForm} onSubmit={model ? onSubmitUpdateCompanies : onSubmitCreateCompanies}>
                 <Flex direction={'column'} gap={'5'}> 
                  {model && 
                <Container>
                <Text>ID записи</Text>
                <TextField.Root name="id" placeholder="ID" readOnly defaultValue={model.id}>

                </TextField.Root>
                </Container>
                }
                <Container> 
                <Text>Ссылка</Text>
                <TextField.Root name="link_to_list_org" type="url" placeholder="Ссылка" defaultValue={model?.link_to_list_org || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Наименование</Text>
                <TextField.Root name="title" placeholder="Наименование" defaultValue={model?.title || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Юридическое наименование</Text>
                <TextField.Root name="legal_name" placeholder="Юридическое наименование" defaultValue={model?.legal_name || ''}>
                </TextField.Root>
               
                </Container>
                 <Container> 
                <Text>Статус</Text>
                <TextField.Root name="status" placeholder="Статус" defaultValue={model?.status || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>Руководитель</Text>
                <TextField.Root name="supervisor" placeholder="Руководитель" defaultValue={model?.supervisor || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>ИНН</Text>
                <MaskInput name="inn" placeholder="ИНН" mask="____________" replacement={{ _: /\d/ }} defaultValue={model?.inn || ''} />
                </Container>
                 <Container> 
                <Text>ОГРН</Text>
                <MaskInput name="ogrn" placeholder="ОГРН" mask="_____________" replacement={{ _: /\d/ }} defaultValue={model?.ogrn || ''} />
                </Container>
                <Container> 
                <Text>Телефон (один из)</Text>
                <TextField.Root name="phone_number" placeholder="Телефон (один из)" defaultValue={model?.phone_number || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>E-mail</Text>
                <TextField.Root name="email" placeholder="E-mail" defaultValue={model?.email || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Сайт</Text>
                <TextField.Root name="site" placeholder="Сайт" type="url" defaultValue={model?.site || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Юридический адрес</Text>
                 <TextField.Root name="legal_address" placeholder="Юридический адрес" defaultValue={model?.legal_address || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Сотрудников</Text>
                <TextField.Root name="employeers" placeholder="Сотрудников" defaultValue={model?.employeers || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Выручка (Ф2.2110)</Text> 
                <TextField.Root name="revenue_f2_2110" placeholder="Выручка (Ф2.2110)" defaultValue={model?.revenue_f2_2110 || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Прибыль (Ф2.2400)</Text> 
                <TextField.Root name="profit_f2_2400" placeholder="Прибыль (Ф2.2400)" defaultValue={model?.profit_f2_2400 || ''}>

                </TextField.Root>
                </Container>
                 <Container>
                <Text>Стоимость (Ф1.1300)</Text> 
                <TextField.Root name="price_f1_1300" placeholder="Стоимость (Ф1.1300)" defaultValue={model?.price_f1_1300 || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Описание</Text>
                  <TextField.Root name="description" placeholder="Описание" defaultValue={model?.description || ''}>

                </TextField.Root>
                </Container>
                  <Container> 
                <Text>В избранном</Text>
                <TextField.Root name="liked" placeholder="В избранном" defaultValue={model?.liked || ''}>

                </TextField.Root>
                </Container>
                <Button loading={isLoadingRegistryCompaniesCreate || isLoadingRegistryCompaniesUpdate}>
                    Сохранить
                </Button>
                </Flex>
                
                </form>
            </Container>
        )
      }

    const renderCreateFactoriesModal = (model: IRegistryFactories | null) => {
        return (
             <Container>
                <form ref={factoriesForm} onSubmit={model ? onSubmitUpdateFactories : onSubmitCreateFactories}>
                 <Flex direction={'column'} gap={'5'}> 
                {model && 
                <Container>
                <Text>ID записи</Text>
                <TextField.Root name="id" placeholder="ID" readOnly defaultValue={model.id}>

                </TextField.Root>
                </Container>
                }
                <Container> 
                <Text>Регионы</Text>
                <TextField.Root name="region" placeholder="Регионы" defaultValue={model?.region || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Предприятия</Text>
                <TextField.Root name="factories" placeholder="Предприятия" defaultValue={model?.factories || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Объединения</Text>
                <TextField.Root name="unions" placeholder="Объединения" defaultValue={model?.unions || ''}>
                </TextField.Root>
               
                </Container>
                 <Container> 
                <Text>Комбинаты</Text>
                <TextField.Root name="plants" placeholder="Комбинаты" defaultValue={model?.plants || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>Лесхозы</Text>
                <TextField.Root name="forestry" placeholder="Лесхозы" defaultValue={model?.forestry || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>Адрес</Text>
                <TextField.Root name="address" placeholder="Адрес" defaultValue={model?.address || ''}>
                </TextField.Root>
                </Container>
                 <Container> 
                <Text>ФИО Руководителя</Text>
                <TextField.Root name="full_name_seo" placeholder="ФИО Руководителя" defaultValue={model?.full_name_seo || ''}>
                </TextField.Root>
                </Container>
                <Container> 
                <Text>Телефон; факс</Text>
                <TextField.Root name="phone_number" placeholder="Телефон; факс" defaultValue={model?.phone_number || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Собственность</Text>
                <TextField.Root name="own" placeholder="Собственность" defaultValue={model?.own || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>инф. по состоянию на</Text>
                <TextField.Root name="date_information" placeholder="инф. по состоянию на" defaultValue={model?.date_information || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>рег. номер</Text>
                 <TextField.Root name="reg_number" placeholder="рег. номер" defaultValue={model?.reg_number || ''}>

                </TextField.Root>
               { errorsRegistryFactoriesCreate.reg_number && <Text color="red">{errorsRegistryFactoriesCreate.reg_number.msg}</Text> }
                </Container>
                <Container>
                <Text>Год основания</Text>
                <TextField.Root name="year_created" placeholder="Год основания" defaultValue={model?.year_created || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Численность чел.</Text> 
                <TextField.Root name="count_personal" placeholder="Численность чел." defaultValue={model?.count_personal || ''}>

                </TextField.Root>
                </Container>
                <Container>
                <Text>Объем</Text> 
                <TextField.Root name="volume" placeholder="Объем" defaultValue={model?.volume || ''}>

                </TextField.Root>
                </Container>
                 <Container>
                <Text>Износ ОФ</Text> 
                <TextField.Root name="wear_of" placeholder="Износ ОФ" defaultValue={model?.wear_of || ''}>

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Остат. стоим. ОФ</Text>
                  <TextField.Root name="remainder_price_of" placeholder="Остат. стоим. ОФ" defaultValue={model?.remainder_price_of || ''}>

                </TextField.Root>
                </Container>
                  <Container> 
                <Text>Продукция и услуги</Text>
                <TextField.Root name="products" placeholder="Продукция и услуги" defaultValue={model?.products || ''}>

                </TextField.Root>
                </Container>
                  <Container> 
                <Text>Использование сырья и материалов</Text>
                <TextField.Root name="using_materials" placeholder="Использование сырья и материалов" defaultValue={model?.using_materials || ''}>

                </TextField.Root>
                </Container>
                <Button loading={isLoadingRegistryFactoriesCreate || isLoadingRegistryFactoriesUpdate}>
                    Сохранить
                </Button>
                </Flex>
                
                </form>
            </Container>
        )
    }

    const onUpdateBookMemory = (model: IRegistryBookMemory) => {
        setSelectedBookMemory(model)
        setOpenRegistryBookMemoryModalUpdate(true)
    }

    const onUpdateNotVerify = (model: IRegistryNotVerify) => {
        setSelectedNotVerify(model)
        setOpenRegistryNotVerifyModalUpdate(true)
    }

    const onUpdatePersonalities = (model: IRegistryPersonalities) => {
        setSelectedPersonalities(model)
        setOpenRegistryPersonalitiesModalUpdate(true)
    }

    const onUpdateCompanies = (model: IRegistryCompanies) => {
        setSelectedCompanies(model)
        setOpenRegistryCompaniesModalUpdate(true)
    }

    const onUpdateFactories = (model: IRegistryFactories) => {
        setSelectedFactories(model)
        setOpenRegistryFactoriesModalUpdate(true)
    }

    

    const registryNotVerifyTableFormat = useMemo(() => {
        
        return registryNotVerify.map(item => {
            console.log(item) 
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Button color="yellow" onClick={() => onUpdateNotVerify(item)}><UpdateIcon /></Button>
                <Button color="red" onClick={async () => await fetchRegistryNotVerifyDelete(item.id)}><CrossCircledIcon /></Button>
                </Flex>
            ]
            return Object.entries(item).concat([actions])
        })
    }, [registryNotVerify])


    const registryPersonalitiesTableFormat = useMemo(() => {
        
        return registryPersonalities.map(item => {
            console.log(item) 
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Button color="yellow" onClick={() => onUpdatePersonalities(item)}><UpdateIcon /></Button>
                <Button color="red" onClick={async () => await fetchRegistryPersonalitiesDelete(item.id)}><CrossCircledIcon /></Button>
                </Flex>
            ]
            return Object.entries(item).concat([actions])
        })
    }, [registryPersonalities])


    const registryBookMemoryTableFormat = useMemo(() => {
         
        return registryBookMemory.map(item => {
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Button color="yellow" onClick={() => onUpdateBookMemory(item)}><UpdateIcon /></Button>
                <Button color="red" onClick={async () => await fetchRegistryBookMemoryDelete(item.id)}><CrossCircledIcon /></Button>
                </Flex>,
            ]
            return Object.entries(item).concat([actions])
    })
    }, [registryBookMemory])

    const registryCompaniesTableFormat = useMemo(() => {
         
        return registryCompanies.map(item => {
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Button color="yellow" onClick={() => onUpdateCompanies(item)}><UpdateIcon /></Button>
                <Button color="red" onClick={async () => await fetchRegistryCompaniesDelete(item.id)}><CrossCircledIcon /></Button>
                </Flex>,
            ]
            return Object.entries(item).concat([actions])
    })
    }, [registryCompanies])

    const registryFactoriesTableFormat = useMemo(() => {
        return registryFactories.map(item => {
            const actions = [
                "Действия",
                <Flex gap={'3'}>
                <Button color="yellow" onClick={() => onUpdateFactories(item)}><UpdateIcon /></Button>
                <Button color="red" onClick={async () => await fetchRegistryFactoriesDelete(item.id)}><CrossCircledIcon /></Button>
                </Flex>,
            ]
            return Object.entries(item).concat([actions])
    })
    }, [registryFactories])
 
    useEffect(() => {
        const form = new FormData(filtersForm.current || undefined)
        if(activeTable === 'not-verify') {
            fetchRegistryNotVerifyFilters(form)
        }
        if(activeTable === 'book-memory') {
            fetchRegistryBookMemoryFilters(form)
        }
        if(activeTable === 'personalities') {
            fetchRegistryPersonalitiesFilters(form)
        }
        if(activeTable === 'companies') {
            fetchRegistryCompaniesFilters(form)
        }
        if(activeTable === 'factories') {
            fetchRegistryFactoriesFilters(form)
        }
    }, [activeTable, registryBookMemoryPage, registryNotVerifyPage, registryPersonalitiesPage, registryCompaniesPage, registryFactoriesPage, dateSort])

    useEffect(() => {
        if (errorRegistryBookMemoryCreate) toast.error(errorRegistryBookMemoryCreate)
    }, [errorRegistryBookMemoryCreate])

    useEffect(() => {
        if (errorRegistryNotVerifyCreate) toast.error(errorRegistryNotVerifyCreate)
    }, [errorRegistryNotVerifyCreate])

    useEffect(() => {
        if (errorRegistryPersonalitiesCreate) toast.error(errorRegistryPersonalitiesCreate)
    }, [errorRegistryPersonalitiesCreate])

    useEffect(() => {
        if(errorRegistryCompaniesCreate) toast.error(errorRegistryCompaniesCreate)
    }, [errorRegistryCompaniesCreate])

    useEffect(() => {
        if (errorRegistryBookMemoryCreateFromExcel) toast.error(errorRegistryBookMemoryCreateFromExcel)
    }, [errorRegistryBookMemoryCreateFromExcel])

    useEffect(() => {
        if(errorRegistryNotVerifyCreateFromExcel) toast.error(errorRegistryNotVerifyCreateFromExcel)
    }, [errorRegistryNotVerifyCreateFromExcel])

    useEffect(() => {
        if(errorRegistryPersonalitiesCreateFromExcel) toast.error(errorRegistryPersonalitiesCreateFromExcel)
    }, [errorRegistryPersonalitiesCreateFromExcel])

    useEffect(() => {
        if(errorRegistryCompaniesCreateFromExcel) toast.error(errorRegistryCompaniesCreateFromExcel)
    }, [errorRegistryCompaniesCreateFromExcel])

    useEffect(() => {
        if(errorRegistryBookMemoryUpdate) toast.error(errorRegistryBookMemoryUpdate)
    }, [errorRegistryBookMemoryUpdate])

    useEffect(() => {
        if(errorRegistryNotVerifyUpdate) toast.error(errorRegistryNotVerifyUpdate)
    }, [errorRegistryNotVerifyUpdate])

    useEffect(() => {
        if(errorRegistryPersonalitiesUpdate) toast.error(errorRegistryPersonalitiesUpdate)
    }, [errorRegistryPersonalitiesUpdate])

    useEffect(() => {
        if(errorRegistryCompaniesUpdate) toast.error(errorRegistryCompaniesUpdate)
    }, [errorRegistryCompaniesUpdate])

    useEffect(() => {
        if(errorRegistryFactoriesCreate) toast.error(errorRegistryFactoriesCreate)
    }, [errorRegistryFactoriesCreate])

    useEffect(() => {
        if(errorRegistryFactoriesCreateFromExcel) toast.error(errorRegistryFactoriesCreateFromExcel)
    }, [errorRegistryFactoriesCreateFromExcel])

    useEffect(() => {
        if(errorRegistryFactoriesUpdate) toast.error(errorRegistryFactoriesUpdate)
    }, [errorRegistryFactoriesUpdate])

    return (
        <Container className="pt-10 pb-10">
            <ToastContainer />
            <Flex gap={'5'} className="mb-10" wrap={"wrap"}>
                  <BaseModal 
                        showButton={<></>}
                        title="Изменить запись в регистре"
                        description={renderCreatePersonalitiesModal(selectedPersonalities)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryPersonalitiesModalUpdate}
                        onOpenChange={setOpenRegistryPersonalitiesModalUpdate}
                    />
                   <BaseModal 
                        showButton={<></>}
                        title="Изменить запись в регистре"
                        description={renderCreateBookMemoryModal(selectedBookMemory)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryBookMemoryModalUpdate}
                        onOpenChange={setOpenRegistryBookMemoryModalUpdate}
                    />
                    <BaseModal 
                        showButton={<></>}
                        title="Изменить запись в регистре"
                        description={renderCreateNotVerifyModal(selectedNotVerify)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryNotVerifyModalUpdate}
                        onOpenChange={setOpenRegistryNotVerifyModalUpdate}
                    />
                    <BaseModal 
                        showButton={<></>}
                        title="Изменить запись в регистре"
                        description={renderCreateCompaniesModal(selectedCompanies)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryCompaniesModalUpdate}
                        onOpenChange={setOpenRegistryCompaniesModalUpdate}
                    />
                     <BaseModal 
                        showButton={<></>}
                        title="Изменить запись в регистре"
                        description={renderCreateFactoriesModal(selectedFactories)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryFactoriesModalUpdate}
                        onOpenChange={setOpenRegistryFactoriesModalUpdate}
                    />
                    <BaseModal 
                       showButton={<Button>Добавить</Button>}
                        title="Добавить запись в регистр"
                        description={activeTable === 'book-memory' ? renderCreateBookMemoryModal(null) : activeTable === 'not-verify' ? renderCreateNotVerifyModal(null) : activeTable === 'personalities' ? renderCreatePersonalitiesModal(null) : activeTable === 'companies' ? renderCreateCompaniesModal(null) : renderCreateFactoriesModal(null)}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryModalCreate}
                        onOpenChange={setOpenRegistryModalCreate}
                    />
                 <BaseModal 
                       showButton={<Button>Добавить записи из Excel</Button>}
                        title="Добавить записи из Excel"
                        description={renderRegistryCreateFromExcelModal}
                        cancelButton={<Button color="red">Отмена</Button>}
                        successButton={<></>}
                        open={openRegistryModalCreateFromExcel}
                        onOpenChange={setOpenRegistryModalCreateFromExcel}
                    />
                  <Button>
                    Распределить финансы для всех
                </Button>
                 <Button>
                    Распределить финансы для одной записи
                </Button>
            </Flex>
            <Container className="border">
                    <Flex className="border p-5" justify={'between'} wrap={'wrap'}>
                        <Flex gap={'5'} wrap={'wrap'}> 
                        <Button variant={activeTable == 'not-verify' ? 'solid' : 'ghost'} onClick={() => setActiveTable('not-verify')}>
                            Неподтвержденные
                        </Button>
                         <Button variant={activeTable == 'book-memory' ? 'solid' : 'ghost'} onClick={() => setActiveTable('book-memory')}>
                            Книга Памяти
                        </Button>
                         <Button variant={activeTable == 'personalities' ? 'solid' : 'ghost'} onClick={() => setActiveTable('personalities')}>
                            Персоналии
                        </Button>
                        <Button variant={activeTable == 'companies' ? 'solid' : 'ghost'} onClick={() => setActiveTable('companies')}>
                            Организации
                        </Button>
                         <Button variant={activeTable == 'factories' ? 'solid' : 'ghost'} onClick={() => setActiveTable('factories')}>
                            Организации 90-х
                        </Button>
                        </Flex>
                        <Button color="grass" onClick={() => onDownloadTemplate()}>
                          <DownloadIcon />  Скачать шаблон текущей таблицы
                        </Button>
                    </Flex>
                       <Container className="filters border p-3">
                        <Flex gap={'5'}> 
                           <Text size={'6'} weight={'bold'}>
                            Фильтры
                           </Text>
                           <Button variant='solid' onClick={() => setFiltersVisible(!filtersVisible)}>
                               {filtersVisible ? "Скрыть" : "Показать"}
                           </Button>
                           </Flex>
                                       <HoverCard.Root>
		<HoverCard.Trigger>
            <Button variant="solid" className="!mb-5 !mt-5"> 
                <MixerVerticalIcon />
			<Text>
                 Сортировать по дате
			</Text>
            </Button>
		</HoverCard.Trigger>
		<HoverCard.Content maxWidth="300px">
			<Flex gap="4">
                   <RadioGroup.Root defaultValue={dateSort} name="date_sort" onValueChange={e => setDateSort(e)}>
                                        <RadioGroup.Item value="DESC">По убыванию</RadioGroup.Item>
                                        <RadioGroup.Item value="ASC">По возрастанию</RadioGroup.Item>
                                        </RadioGroup.Root>
			</Flex>
		</HoverCard.Content>
	</HoverCard.Root>
                            <Flex direction={'column'} className={`filters ${filtersVisible ? '!flex' : '!hidden'}`}>
                                <form ref={filtersForm} onSubmit={async e => await onSubmitFilters(e)}> 
                                {activeTable !== 'companies' && activeTable !== 'factories' ? 
                                <Flex gap={'3'} direction={'column'}>
                                <Container> 
                                <Text>
                                    Имя
                                </Text>
                                <TextField.Root name="first_name" placeholder="Имя">

                                </TextField.Root>
                                </Container>
                                <Container> 
                                     <Text>
                                    Фамилия
                                </Text>
                                  <TextField.Root name="second_name" placeholder="Фамилия">

                                </TextField.Root>
                                </Container>
                                <Container> 
                                     <Text>
                                    Отчество
                                </Text>
                                  <TextField.Root name="sur_name" placeholder="Отчество">

                                </TextField.Root>
                                </Container>
                                <Container> 
                                     <Text>
                                    Дата рождения
                                </Text>
                                  <TextField.Root name="date_of_birth" placeholder="Дата рождения" type="date">

                                </TextField.Root>
                                </Container>
                                <Container> 
                                     <Text>
                                    Дата смерти
                                </Text>
                                   <TextField.Root name="date_of_death" placeholder="Дата смерти" type="date">

                                </TextField.Root>
                                </Container>
                                <Container> 
                                     <Text>
                                    Гражданство
                                </Text>
                                  <TextField.Root name="nationality" placeholder="Гражданство">
                                
                                </TextField.Root>
                                </Container>
                                {activeTable === 'not-verify' && 
                                    <Flex direction={'column'} gap={'5'}> 
                                  <Container>
                    <Text>Пол</Text>
                    <RadioGroup.Root name="sex">
	                <RadioGroup.Item value="М">Мужской</RadioGroup.Item>
	                <RadioGroup.Item value="Ж">Женский</RadioGroup.Item>
                    </RadioGroup.Root>
                </Container>
                                <Container> 
                <Text>Серия паспорта</Text>
                <MaskInput name="series_passport" placeholder="Серия паспорта" mask="____" replacement={{ _: /\d/ }} />
                </Container>
                 <Container> 
                <Text>Номер паспорта</Text>
                <MaskInput name="number_passport" placeholder="Номер паспорта" mask="______" replacement={{ _: /\d/ }} />
                </Container>
                <Container> 
                <Text>Кем выдан паспорт</Text>
                <TextField.Root name="whom_issue_passport" placeholder="Кем выдан паспорт">

                </TextField.Root>
                </Container>
                <Container>
                <Text>Дата выдачи паспорта</Text>
                <TextField.Root name="date_issue_passport" placeholder="Дата выдачи паспорта" type="date">

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Код подразделения паспорта</Text>
                <MaskInput name="department_code_passport" placeholder="Код подразделения паспорта" mask="___-___" replacement={{ _: /\d/ }} />
                </Container>
                <Container> 
                <Text>ИНН</Text>
                <MaskInput name="inn" placeholder="ИНН" mask="____________" replacement={{ _: /\d/ }} />
                </Container>
                <Container> 
                <Text>СНИЛС</Text>
                <MaskInput name="snils" placeholder="СНИЛС" mask="___-___-___ __" replacement={{ _: /\d/ }} />
                </Container>
                <Container>
                <Text>Номер полиса ОМС</Text>
                <MaskInput name="oms" placeholder="Номер полиса ОМС" mask="________________" replacement={{ _: /\d/ }} />
                </Container>
                <Container>
                <Text>Серия Свидетельства о рождении</Text> 
                <TextField.Root name="document_of_date_birth_series" placeholder="Серия Свидетельства о рождении">

                </TextField.Root>
                </Container>
                <Container>
                <Text>Номер Свидетельства о рождении</Text> 
                <TextField.Root name="document_of_date_birth_number" placeholder="Номер Свидетельства о рождении">

                </TextField.Root>
                </Container>
                <Container>
                <Text>Свидетельство о рождении кем выдано</Text> 
                <TextField.Root name="document_of_date_birth_whom_issue" placeholder="Свидетельство о рождении кем выдано">

                </TextField.Root>
                </Container>
                 <Container>
                <Text>Свидетельство о рождении когда выдано</Text> 
                <TextField.Root name="document_of_date_birth_date_issue" type="date" placeholder="Свидетельство о рождении когда выдано">

                </TextField.Root>
                </Container>
                <Container> 
                <Text>Серия военного билета</Text>
                <MaskInput name="series_military_document" placeholder="AA" mask="++" replacement={{ "+": /[A-Za-zА-Яа-я]/ }} />
                </Container>
                  <Container> 
                <Text>Номер военного билета</Text>
                <MaskInput name="number_military_document" placeholder="0000000" mask="_______" replacement={{ _: /\d/, }} />
                </Container>
                
                                </Flex>
                                
                                }
                                </Flex>
                                : activeTable === 'companies' ?
                                <Flex gap={'3'} direction={'column'}>
                                    <Container>
                                        <Text>
                                            Наименование
                                        </Text>
                                        <TextField.Root name="title" placeholder="Наименование">

                                        </TextField.Root>
                                    </Container>
                                     <Container>
                                        <Text>
                                            Юридическое наименование
                                        </Text>
                                        <TextField.Root name="legal_name" placeholder="Юридическое наименование">

                                        </TextField.Root>
                                    </Container>
                                      <Container>
                                        <Text>
                                            Статус
                                        </Text>
                                        <TextField.Root name="status" placeholder="Статус">

                                        </TextField.Root>
                                    </Container>
                                       <Container>
                                        <Text>
                                            ИНН
                                        </Text>
                                        <TextField.Root name="inn" placeholder="ИНН">

                                        </TextField.Root>
                                    </Container>
                                </Flex>
                                : activeTable === 'factories' &&
                                <Flex gap={'3'} direction={'column'}>
                                     <Container>
                                        <Text>
                                            Рег. номер
                                        </Text>
                                        <TextField.Root name="reg_number" placeholder="Рег. номер">

                                        </TextField.Root>
                                    </Container>
                                       <Container>
                                        <Text>
                                            Предприятие
                                        </Text>
                                        <TextField.Root name="factories" placeholder="Предприятие">

                                        </TextField.Root>
                                    </Container>
                                </Flex>
}                                
                                <Flex gap={'5'} className="mt-5"> 
                                <Button variant='classic' loading={isLoadingRegistryBookMemoryFilters || isLoadingRegistryNotVerifyFilters || isLoadingRegistryPersonalitiesFilters || isLoadingRegistryFactoriesFilters}>
                                    Применить
                                </Button>
                                <Button variant='outline' onClick={(e) =>{e.preventDefault(); filtersForm.current?.reset()}}>
                                    Сбросить
                                </Button>
                                </Flex>
                                </form>
                            </Flex>
                        </Container>
                    <Flex>
                        <Container className={activeTable === 'not-verify' ? '!flex' : '!hidden'}> 
                        <AppTable 
                        headers={registryNotVerifyHeadersTableFormat} 
                        data={registryNotVerifyTableFormat} 
                        renderOption={renderOption}
                        />
                        <Pagination 
                        total={registryNotVerifyTotal}
                        count={registryNotVerifyCount}
                        activeIndex={registryNotVerifyPage}
                        onChangeIndex={onChangePage}
                        />
                        </Container>
                        <Container className={activeTable === 'book-memory' ? '!flex' : '!hidden'}> 
                        <AppTable 
                        headers={registryBookMemoryHeadersTableFormat}
                        data={registryBookMemoryTableFormat} 
                        renderOption={renderOption}
                        />
                        <Pagination 
                        total={registryBookMemoryTotal}
                        count={registryBookMemoryCount}
                        activeIndex={registryBookMemoryPage}
                        onChangeIndex={onChangePage}
                        />
                        </Container>
                        <Container className={activeTable === 'personalities' ? '!flex' : '!hidden'}> 
                        <AppTable 
                        headers={registryPersonalitiesHeadersTableFormat} 
                        data={registryPersonalitiesTableFormat} 
                        renderOption={renderOption}
                        />
                        <Pagination 
                        total={registryPersonalitiesTotal}
                        count={registryPersonalitiesCount}
                        activeIndex={registryPersonalitiesPage}
                        onChangeIndex={onChangePage}
                        />
                        </Container>
                        <Container className={activeTable === 'companies' ? '!flex' : '!hidden'}>
                            <AppTable
                            headers={registryCompaniesHeadersTableFormat}
                            data={registryCompaniesTableFormat}
                            renderOption={renderOption}
                            />
                            <Pagination
                            total={registryCompaniesTotal}
                            count={registryCompaniesCount}
                            activeIndex={registryCompaniesPage}
                            onChangeIndex={onChangePage}
                            />
                        </Container>
                         <Container className={activeTable === 'factories' ? '!flex' : '!hidden'}>
                            <AppTable
                            headers={registryFactoriesHeadersTableFormat}
                            data={registryFactoriesTableFormat}
                            renderOption={renderOption}
                            />
                            <Pagination
                            total={registryFactoriesTotal}
                            count={registryFactoriesCount}
                            activeIndex={registryFactoriesPage}
                            onChangeIndex={onChangePage}
                            />
                        </Container>
                    </Flex>
            </Container>
        </Container>
    )
}